/* eslint-disable import/prefer-default-export */
import * as React from 'react'
import type { RouteProps as ReactRouteProps } from 'react-router-dom'
import { withFilter } from '@src/hocs'
import { useAbortController } from '@src/components/abort.controller'
import { SecureRoute } from '@src/modules/oauth'
import type { FilterAccount } from '@src/redux/reducers/filter/default.state'

export interface RouteProps extends ReactRouteProps {
  disabled?: boolean
  currentAccount?: FilterAccount
  withFilter?: boolean
}

export type RouteWithFilterProps = Omit<RouteProps, 'withFilter'>

export const RouteWithFilter: React.FC<RouteWithFilterProps> = React.memo(
  ({ exact, component, path, currentAccount }: RouteWithFilterProps) => (
    <SecureRoute
      exact={exact}
      path={`${path}/:accountId?`}
      component={withFilter(component, {
        currentAccount
      })}
    />
  )
)

export const AbortControllerRoute: React.FC<RouteProps> = React.memo(
  (props: RouteProps) => {
    const component = props.component
      ? useAbortController(props.component)
      : null
    const routeProps: RouteProps = {
      ...props,
      component
    }
    return <Route {...routeProps} />
  }
)

export const Route: React.FC<RouteProps> = React.memo((props: RouteProps) => {
  const { withFilter, disabled } = props
  if (disabled) {
    return null
  }
  return withFilter ? (
    <RouteWithFilter {...props} />
  ) : (
    <SecureRoute {...props} />
  )
})
